import React from "react";

import styles from "./styles.module.css";

import { UserContext } from "../../UserContext";

const Contato = () => {
  const { data, permission, modules } = React.useContext(UserContext);


  return (
    <main className="container container-page-main">

      <div id="main">

        <div class="breadcrumb-section">
          <div class="container">
            <h1>Fale Conosco</h1>
            <div class="breadcrumb">
              <a href="index.html">Home</a>
              <span class="fa fa-angle-double-right"></span>
              <span class="current">Fale Conosco</span>
            </div>
          </div>
        </div>


        <div class="container">

          <section id="primary" class="content-full-width">

            

            <div class="column dt-sc-three-fourth first contact_form_outer">
              <div id="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.7424639878977!2d-46.36266302489157!3d-23.541763478813294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce7bf768758167%3A0xc9922c5e32241b01!2sCl%C3%ADnica%20CreSer!5e0!3m2!1spt-BR!2sbr!4v1726935838733!5m2!1spt-BR!2sbr"
                  title="Endereço clinica Crescer"
                  width="100%"
                  height="500"
                  className={styles.googleMaps}
                />
              </div>
            </div>


            <div class="column dt-sc-one-fourth class_hours">
              <h2>Horário de atendimento</h2>
              <ul class="class_hours">
                <li>Segunda<span>10am - 19pm</span></li>
                <li>Terça<span>10am - 19pm</span></li>
                <li>Quarta<span>10am - 19pm</span></li>
                <li>Quinta<span>10am - 19pm</span></li>
                <li>Sexta<span>10am - 19pm</span></li>
                <li>Sabado<span>FECHADO</span></li>
                <li>Domingo<span>FECHADO</span></li>
              </ul>
              <div class="dt-sc-hr-small"></div>
              <aside class="widget widget_text">
                          {/* <h3 class="widgettitle steelblue_sketch">Contato</h3> */}
                          <div class="textwidget">
                              <p class="dt-sc-contact-info"><span class="fa fa-map-marker"></span> R. Benedito Leite, 52 - Vila Correa, Ferraz de Vasconcelos - SP </p>
                              <p class="dt-sc-contact-info"><span class="fa fa-phone"></span> (11) 91913-9787 </p>
                              <p class="dt-sc-contact-info"><span class="fa fa-envelope"></span><a
                                      href="clinicacrescerferraz@hotmail.com">
                                      <span class="__cf_email__">clinicacrescerferraz@hotmail.com</span>
                                  </a></p>
                          </div>
                      </aside>
              {/* <p><strong><span class="highlighter">Nossas</span> redes sociais</strong></p>
              <ul class="dt-sc-social-icons">
                <li class="facebook"><a href="#" title="Facebook" class="dt-sc-tooltip-bottom"><img src="images/facebook.png" /></a></li>
                <li class="twitter"><a href="#" title="Twitter" class="dt-sc-tooltip-bottom"><img src="images/twitter.png" /></a></li>
                <li class="gplus"><a href="#" title="Google Plus" class="dt-sc-tooltip-bottom"><img src="images/gplus.png" /></a></li>
                <li class="pinterest"><a href="#" title="Pinterest" class="dt-sc-tooltip-bottom"><img src="images/pinterest.png" /></a></li>
              </ul> */}
            </div>

          </section>

        </div>

      </div>


    </main>
  );
};

export default Contato;
